import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { TagService } from "../../../services/api/tag.service";
import { MpCommonActions } from "../../actions/mp-common.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class TagsEffects {
	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.tags.getApi),
			switchMap((action) => {
				return this.tagService.getTags().pipe(
					map((tags) =>
						MpCommonActions.tags.getSuccess({
							tags,
							loading: false
						})
					),
					catchError((error) => of(MpCommonActions.tags.getFail(new FailState(error))))
				);
			})
		)
	);

	create = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.tags.create),
			switchMap((action) =>
				this.tagService.createTag(action.request).pipe(
					map((tag) => MpCommonActions.tags.createSuccess(tag)),
					catchError((error) => of(MpCommonActions.tags.createFail(new FailState(error))))
				)
			)
		)
	);

	update = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.tags.update),
			switchMap((action) =>
				this.tagService.updateTag(action.request).pipe(
					map((tag) => MpCommonActions.tags.updateSuccess(tag)),
					catchError((error) => of(MpCommonActions.tags.updateFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private tagService: TagService
	) {}
}
